<div class="tw-relative tw-py-8 tw-flex tw-flex-col tw-items-center tw-gap-8 tw-px-6">
  <!-- Close Button -->
  <div
    class="tw-absolute tw-top-3 tw-right-3 tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-bg-gray-100 tw-rounded-full tw-cursor-pointer"
    (click)="close()">
    <span class="tw-text-black tw-font-bold tw-text-400 tw-leading-none">&#10005;</span>
  </div>

  <div class="tw-flex tw-flex-col tw-gap-8 tw-items-start">
    <!-- Image + Title + Description -->
    <div class="tw-flex tw-flex-col tw-gap-5 tw-items-center">
      <div class="tw-flex tw-flex-col tw-items-center">
        <div class="tw-flex tw-flex-col tw-gap-[10px] tw-items-center ">
          <div class="tw-flex tw-flex-col tw-gap-4 tw-items-center">
            <!-- Image Placeholder -->
            <img [src]="kitImage" class="tw-h-32 tw-w-40 tw-rounded-2.5" alt="treatment_kit"/>

            <!-- Title -->
            @if(data.regimenClass === ApiClientConstant.Regimen.Class.HAIR) {
              <p
                class="tw-font-lexend tw-font-bold tw-text-700 tw-leading-[25px] tw-text-gray-900 tw-text-center tw-capitalize"
                i18n="@@followupNudgeHairTitle">
                Update your Hair kit before ordering
              </p>
            } @else {
              <p
                class="tw-font-lexend tw-font-bold tw-text-700 tw-leading-[25px] tw-text-gray-900 tw-text-center tw-capitalize"
                i18n="@@followupNudgeSkinTitle">
                Update your Skin kit before ordering
              </p>
            }
          </div>

          <!-- Description -->
          <div class="tw-font-body tw-font-medium tw-text-300 tw-leading-[20px] tw-text-gray-500 tw-text-center tw-pl-2 tw-pr-4">
            @if (data.type === FOLLOWUP_NUDGE_TYPE.NO_FOLLOWUP) {
              <p i18n="@@followupNudgeZeroDesc">
                Your kit hasn't been updated since your first order.
                Update it with a quick doctor checkup for better, more effective results.
              </p>
            } @else if (data.type === FOLLOWUP_NUDGE_TYPE.OVERDUE) {
              <p i18n="@@followupNudgeOverdueDesc">
                This kit was last updated on {{ formattedFollowUpDate | date:'d MMM, yyyy' }}.
                Update it with a quick doctor checkup for better, more effective results.
              </p>
            } @else if (data.type === FOLLOWUP_NUDGE_TYPE.UPCOMING) {
              <p i18n="@@followupNudgeUpcomingDesc">
                You have a checkup on {{ formattedFollowUpDate | date:'d MMM' }} where your doctor may update your treatment.
                Take it now to order your latest kit.
              </p>
            }
          </div>

        </div>
      </div>
    </div>

    <!-- CTAs -->
    <div class="tw-flex tw-flex-col tw-gap-2 tw-m-auto tw-w-full">
      <button
        csButton
        type="button"
        [loading]="takeCheckupLoading"
        class="tw-w-full tw-max-w-full"
        (click)="takeCheckup()"
        i18n="@@followupNudgeTakeCheckup">
        Take Checkup to update
      </button>


      <button csButton="muted"
              type="button"
              class="tw-w-full tw-text-[18px]"
              (click)="orderWithoutUpdating()"
              i18n="@@followupNudgeOrderWithoutUpdating">Order without updating
      </button>

    </div>
  </div>
</div>
